import { render, staticRenderFns } from "./Obrigado.vue?vue&type=template&id=52a9e7d4&scoped=true"
import script from "./Obrigado.vue?vue&type=script&lang=js"
export * from "./Obrigado.vue?vue&type=script&lang=js"
import style0 from "./Obrigado.vue?vue&type=style&index=0&id=52a9e7d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a9e7d4",
  null
  
)

export default component.exports